import React, { useContext, useEffect, useCallback, useState } from 'react';
import { AuthContext } from '../App';
import { useNavigate } from 'react-router-dom'; // Օգտագործում ենք ստանդարտ հուքը
import { FaGlobe, FaSignOutAlt, FaHome, FaEdit, FaUsers, FaUserAlt, FaPhoneAlt, FaVideo, FaImage } from "react-icons/fa";
import { RxScissors } from "react-icons/rx";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { GiWool } from "react-icons/gi";
import { MdOutlineConstruction, MdEmail, MdDescription, MdTitle } from "react-icons/md";
import '../style/Dashboard.scss';

export const sections = [
    {
        id: 'web',
        title: 'Վեբ ծրագրավորում',
        slagon:`Կոդավորի՛ր քո ապագան տեխնոլոգիաների աշխարհում։`,
        name:'Լիաննա Գալստյան',
        icon: <FaGlobe />,
        tel: '+37477053446',
        bio: `«ԱՌԴԱ» կենտրոնի Վեբ ծրագրավորման դասընթացը միայն տեսություն չէ. սա ձեր մուտքն է ամենաբարձր վարձատրվող ոլորտ։ Մենք սովորեցնում ենք ստեղծել ժամանակակից, արագ և ինտերակտիվ կայքեր՝ օգտագործելով ամենապահանջված գործիքները (HTML, CSS, JavaScript, React և այլն)`,
        pictures: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
        what:`Դուք չեք սովորում չոր կոդեր, դուք ստեղծում եք իրական նախագծեր ձեր պորտֆոլիոյի համար։ Դասընթացի ավարտին դուք պատրաստի կրտսեր (Junior) մասնագետ եք, ով տիրապետում է միջազգային ստանդարտներին։`
    },
    {
        id: 'hair',
        title: 'Վարսահարդարում',
        slagon: `Տիրապետի՛ր գեղեցկության ստեղծման գաղտնիքներին։`,
        name: 'Լյուսի Բողարյան',
        icon: <RxScissors />,
        tel: '+37494450524',
        bio: `Դարձի՛ր ոճ ստեղծող, ում մոտ հերթագրվում են ամիսներ առաջ։ Մեր դասընթացը ներառում է ամեն ինչ՝ դասական կտրվածքներից մինչև ամենաբարդ գունաբանական (coloristics) լուծումներն ու տոնական սանրվածքները։`,
        pictures: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
        what: `Ուսուցումն իրականացվում է պրոֆեսիոնալ նյութերով և գործիքներով։ Շեշտը դրվում է ձեռքի վարժության և հաճախորդի հետ հոգեբանական աշխատանքի վրա։ Մենք ձեզ տալիս ենք ոչ միայն վկայական, այլև սեփական սալոնը բացելու կամ լավագույն ստուդիաներում աշխատելու վստահություն։`
    },
    {
        id: 'bild',
        title: 'Շինաշխատանքներ',
        slagon: `Որակյալ արհեստ՝ կայուն եկամուտ։`,
        name: 'Գևորգ Թամարյան',
        icon: <MdOutlineConstruction />,
        tel: '+37493101800',
        bio: `Ժամանակակից շինարարության մեջ ամենապահանջվածը «գրագետ վարպետն» է։ «ԱՌԴԱ»-ն առաջարկում է գործնական դասընթացներ, որոնք ներառում են ներքին հարդարման, գիպսակարտոնային կոնստրուկցիաների, սալիկապատման և եվրոպական ստանդարտներով նորարարական տեխնոլոգիաների կիրառումը։`,
        pictures: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
        what: `Մենք սովորեցնում ենք ճիշտ հաշվարկել նյութերը, կարդալ գծագրերը և աշխատանքը կատարել այնպիսի ճշգրտությամբ, որը ձեզ կդարձնի շուկայի ամենափնտրված մասնագետը։ Ձեր ձեռքերը կդառնան ձեր հարստությունը։`
    },
    {
        id: 'shyux',
        title: 'Շյուղագործություն',
        slagon: `Ավանդական արհեստի և ժամանակակից նորաձևության համադրություն։`,
        name: 'Մարինե Սինանյան',
        icon: <GiWool />,
        tel: '+37498883825',
        bio: `Ձեռագործ աշխատանքն այսօր թանկարժեք հոբբիից վերածվել է եկամտաբեր բիզնեսի (Etsy, Instagram հարթակներում)։ Մեր դասընթացի ընթացքում դուք կսովորեք շյուղագործության և հելունագործության բարդ նախշերը, հագուստի մոդելավորումը և դիզայներական էլեմենտների ստեղծումը։`,
        pictures: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
        what: `Մենք օգնում ենք ձեզ զարգացնել ստեղծագործական մտածողությունը։ Դուք կսովորեք ստեղծել էքսկլյուզիվ նմուշներ, որոնք մրցունակ կլինեն թե՛ տեղական, թե՛ միջազգային շուկայում։ Դարձրե՛ք ձեր սիրելի զբաղմունքը բարձրակարգ աշխատանք։`
    }
];




const Dashboard = () => {
    const { user, handleLogout, registrations, setRegistrations } = useContext(AuthContext);
    const navigate = useNavigate();

    // Փոփոխված վիճակ՝ տարբեր մոդալներ կառավարելու համար
    const [activeModal, setActiveModal] = useState(null); 
    const [activeSectionId, setActiveSectionId] = useState(null);

    // Ֆայլերի state-եր
    const [selectedFile, setSelectedFile] = useState(null);
    const [contentImage, setContentImage] = useState(null);
    const [contentVideo, setContentVideo] = useState(null);

    const [trainerInfo, setTrainerInfo] = useState({ name: '', tel: '' });
    const [contentBlock, setContentBlock] = useState({
        title: '',
        desc: ''
    });
    const [manageContent, setManageContent] = useState([]); // JSON-ից ստացված ցանկը
    const [selectedIds, setSelectedIds] = useState([]); // Չեքբոքսով նշված ID-ները

    const fetchRegistrations = useCallback(() => {
        if (user?.access) {
            fetch(`/admin/registrations/${user.access}`)
                .then(res => res.json())
                .then(data => setRegistrations(Array.isArray(data) ? data : []))
                .catch(err => console.error("Error fetching registrations:", err));
        }
    }, [user, setRegistrations]);

    useEffect(() => { fetchRegistrations(); }, [fetchRegistrations]);

    // Մոդալների բացման ֆունկցիաներ
    const handleEditTrainerClick = (sectionId) => {
        setActiveSectionId(sectionId);
        setActiveModal('trainer');
        fetch(`/api/content/${sectionId}`)
            .then(res => res.json())
            .then(data => {
                setTrainerInfo({ name: data.name || '', tel: data.tel || '' });
            });
    };

    const handleAddContentClick = (sectionId) => {
        setActiveSectionId(sectionId);
        setActiveModal('content');
    };

    // Դասընթացավարի պահպանում
    const handleSaveTrainer = () => {
        const formData = new FormData();
        formData.append('sectionId', activeSectionId);
        formData.append('name', trainerInfo.name);
        formData.append('tel', trainerInfo.tel);
        if (selectedFile) formData.append('image', selectedFile);

        fetch('/api/trainer/update', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    alert("Տվյալները թարմացվեցին");
                    setActiveModal(null);
                    setSelectedFile(null);
                }
            })
            .catch(err => alert("Սխալ տվյալները ուղարկելիս"));
    };

    // Նոր կոնտենտի պահպանում
    const handleSaveContent = () => {
        const formData = new FormData();
        formData.append('sectionId', activeSectionId);
        formData.append('title', contentBlock.title);
        formData.append('desc', contentBlock.desc);

        if (contentImage) formData.append('image', contentImage);
        if (contentVideo) formData.append('video', contentVideo);

        fetch('/api/content/add', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    alert("Կոնտենտը հաջողությամբ ավելացվեց");
                    setActiveModal(null);
                    setContentBlock({ title: '', desc: '' });
                    setContentImage(null);
                    setContentVideo(null);
                }
            })
            .catch(err => alert("Սխալ կոնտենտը ուղարկելիս"));
    };
    // Բացել կառավարման մոդալը և բեռնել տվյալները
    const handleManageContentClick = (sectionId) => {
        setActiveSectionId(sectionId);
        setActiveModal('manage');
        fetch(`/api/content/list/${sectionId}`)
            .then(res => res.json())
            .then(data => setManageContent(data))
            .catch(err => console.error("Error loading content:", err));
    };

    // Չեքբոքսի փոփոխություն
    const handleCheckboxChange = (id) => {
        setSelectedIds(prev =>
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };

    // Ջնջման ֆունկցիա
    const handleDeleteContent = () => {
        if (selectedIds.length === 0) return alert("Նշեք գոնե մեկ էլեմենտ");

        if (window.confirm("Համոզվա՞ծ եք, որ ցանկանում եք ջնջել նշվածները:")) {
            fetch('/api/content/delete', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ sectionId: activeSectionId, idsToDelete: selectedIds })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setManageContent(prev => prev.filter(item => !selectedIds.includes(item.id)));
                        setSelectedIds([]);
                        alert("Ջնջված է");
                    }
                });
        }
    };
    if (!user) return <div className="loader">Մուտքը մերժված է...</div>;

    return (
        <div className="dashboard-wrapper">
            <aside className="sidebar">
                <nav className="side-nav">
                    <button onClick={() => navigate('/')}><FaHome /> Գլխավոր</button>
                    <button className="logout-btn" onClick={handleLogout}><FaSignOutAlt /> Ելք</button>
                </nav>
            </aside>

            <main className="dashboard-main">
                <header className="main-header">
                    <h1>Բարի գալուստ, {user.role}</h1>
                    <div className="user-badge">Հասանելիություն: <span>{user.access}</span></div>
                </header>

                <div className="stats-grid">
                    {sections
                        .filter(sec => user.role === 'superadmin' || user.access === sec.id)
                        .map(sec => {
                            const sectionRegistrations = registrations.filter(r => r.targetAdminPhone === sec.tel);

                            return (
                                <div key={sec.id} className="stat-card">
                                    <div className="card-top">
                                        <div className="card-icon">{sec.icon}</div>
                                        <div className="card-info">
                                            <h3>{sec.title}</h3>
                                            <p><FaUsers /> Հայտեր: <strong>{sectionRegistrations.length}</strong></p>
                                        </div>
                                    </div>

                                    <div className="registration-list">
                                        {sectionRegistrations.length > 0 ? (
                                            <div className="scroll-area">
                                                {sectionRegistrations.map((reg, index) => (
                                                    <div key={index} className="reg-item">
                                                        <p><FaUserAlt className="item-icon" /> {reg.name}</p>
                                                        <p><FaPhoneAlt className="item-icon" />
                                                            <a href={`tel:${reg.userPhone}`}>{reg.userPhone}</a>
                                                        </p>
                                                        <p><MdEmail className="item-icon" /> {reg.userEmail}</p>
                                                        <span className="reg-date">{reg.date}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="no-data">Հայտեր դեռ չկան</p>
                                        )}
                                    </div>

                                    <button className="edit-trigger" onClick={() => handleEditTrainerClick(sec.id)}>
                                        <FaEdit /> Խմբագրել Դասընթացավարի տվյալները
                                    </button>
                                    <button className="edit-trigger content-add-btn" onClick={() => handleAddContentClick(sec.id)}>
                                        <FaEdit /> Ավելացնել նոր կոնտենտ
                                    </button>
                                    <button className="edit-trigger content-manage-btn" onClick={() => handleManageContentClick(sec.id)}>
                                        <RiDeleteBin6Fill /> Կոնտենտի Կառավարում
                                    </button>
                                </div>
                            );
                        })
                    }
                </div>


            </main>

            {/* ՄՈԴԱԼ 1: Դասընթացավարի խմբագրում */}
            {activeModal === 'trainer' && (
                <div className="modal-overlay">
                    <div className="edit-modal">
                        <h3>Խմբագրել դասընթացավարին: {activeSectionId}</h3>
                        <div className="modal-content">
                            <label>Անուն Ազգանուն
                                <input
                                    type="text"
                                    value={trainerInfo.name}
                                    onChange={(e) => setTrainerInfo({ ...trainerInfo, name: e.target.value })}
                                />
                            </label>
                            <label>Հեռախոսահամար
                                <input
                                    type="tel"
                                    value={trainerInfo.tel}
                                    onChange={(e) => setTrainerInfo({ ...trainerInfo, tel: e.target.value })}
                                />
                            </label>
                            <label>Նկար (համակարգչից)
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setSelectedFile(e.target.files[0])}
                                />
                            </label>
                        </div>
                        <div className="modal-actions">
                            <button onClick={handleSaveTrainer} className="save-btn">Պահպանել</button>
                            <button onClick={() => setActiveModal(null)} className="cancel-btn">Չեղարկել</button>
                        </div>
                    </div>
                </div>
            )}

            {/* ՄՈԴԱԼ 2: Նոր Կոնտենտի ավելացում */}
            {activeModal === 'content' && (
                <div className="modal-overlay">
                    <div className="edit-modal">
                        <h3>Ավելացնել նոր կոնտենտ ({activeSectionId})</h3>
                        <div className="modal-content">
                            <label><MdTitle /> Վերնագիր
                                <input
                                    type="text"
                                    value={contentBlock.title}
                                    onChange={(e) => setContentBlock({ ...contentBlock, title: e.target.value })}
                                    placeholder='Կոնտենտի վերնագիրը'
                                />
                            </label>
                            <label><MdDescription /> Նկարագրություն
                                <textarea
                                    value={contentBlock.desc}
                                    onChange={(e) => setContentBlock({ ...contentBlock, desc: e.target.value })}
                                    placeholder='Մանրամասն նկարագրություն...'
                                />
                            </label>
                            <label><FaImage /> Նկար
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setContentImage(e.target.files[0])}
                                />
                            </label>
                            <label><FaVideo /> Տեսանյութ
                                <input
                                    type="file"
                                    accept="video/*"
                                    onChange={(e) => setContentVideo(e.target.files[0])}
                                />
                            </label>
                        </div>
                        <div className="modal-actions">
                            <button onClick={handleSaveContent} className="save-btn">Ավելացնել</button>
                            <button onClick={() => setActiveModal(null)} className="cancel-btn">Չեղարկել</button>
                        </div>
                    </div>
                </div>
            )}
            {activeModal === 'manage' && (
                <div className="modal-overlay">
                    <div className="edit-modal manage-modal">
                        <h3>Կառավարել կոնտենտը ({activeSectionId})</h3>
                        <div className="modal-content scroll-area">
                            {manageContent.length > 0 ? (
                                <table className="content-table">
                                    <thead>
                                        <tr>
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => setSelectedIds(e.target.checked ? manageContent.map(i => i.id) : [])}
                                                    checked={selectedIds.length === manageContent.length && manageContent.length > 0}
                                                />
                                            </th>
                                            <th>Վերնագիր</th>
                                            <th>Նկարագրություն</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {manageContent.map(item => (
                                            <tr key={item.id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedIds.includes(item.id)}
                                                        onChange={() => handleCheckboxChange(item.id)}
                                                    />
                                                </td>
                                                <td>{item.title}</td>
                                                <td className="truncate">{item.desc}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : <p>Այս բաժնում կոնտենտ չկա:</p>}
                        </div>
                        <div className="modal-actions">
                            <button
                                onClick={handleDeleteContent}
                                className="delete-btn"
                                disabled={selectedIds.length === 0}
                            >
                                Ջնջել ընտրվածները ({selectedIds.length})
                            </button>
                            <button onClick={() => { setActiveModal(null); setSelectedIds([]); }} className="cancel-btn">
                                Փակել
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dashboard;